export default "__VITE_ASSET__Dkli2CBx__"